import { ENDPOINTS } from "config/endpoints";
import client from "utils/client";
import { useQuery } from "react-query";
import { Request } from "types/request";
import { PaginatedResponse } from "types/response";
import Error from "types/error";
import { Collection } from "types/collection";

export default function useCollections(params: Record<string, any>) {
  const request: Request = {
    url: ENDPOINTS.collections.all,
    config: {
      method: "GET",
      params,
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.collections.all, params && JSON.stringify(params)],
    queryFn: () => client(request).then((res) => res.data),
  };

  const { data, ...rest } = useQuery<PaginatedResponse<Collection[]>, Error>(requestConfig);

  return { data, ...rest };
}
